module.exports = __webpack_public_path__ + "img/map_Z1.3.B.03.322f16d9.svg";